/**
 * HTML email body templates for connection-related emails (Connect by SMBF).
 */

export function getConnectionRequestEmailBody(firstName?: string): string {
  return `<!DOCTYPE html><html lang="en"><head>
<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0"/>
<title>Connect by SMBF</title>
</head><body style="margin:0; padding:0; font-family:Arial, Helvetica, sans-serif; background-color:#f4f6f8;">
<table width="100%" border="0" cellspacing="0" cellpadding="0" bgcolor="#f4f6f8">
  <tr>
    <td align="center" style="padding:40px 20px;">
      <table width="600" border="0" cellspacing="0" cellpadding="0" bgcolor="#ffffff"
        style="border-radius:10px; border:1px solid #e0e0e0; overflow:hidden;">
        <tr>
          <td align="center" style="background: linear-gradient(221deg, #2366CD 0%, #3A97A4 100%); padding:30px;">
            <img src="https://drive.google.com/uc?export=view&id=17bPec3b1DFm41gg757oKNyTmP1942OMg"
              alt="Connect by SMBF" width="180"
              style="max-width:180px; height:auto; display:block; margin:0 auto;" />
          </td>
        </tr>
        <tr>
          <td style="padding:35px; text-align:left; color:#333333; font-size:15px; line-height:1.6;">
            <h2 style="color:#2366CD; font-size:22px; margin:0 0 20px;">
              Assalamu Alaikum ${firstName ?? ""},
            </h2>
            <p style="margin:0 0 15px;">
              Another member on <b>Connect by SMBF</b> wants to connect with you.
            </p>
            <p style="margin:0 0 25px;">
              Review their profile and accept to start a conversation.
            </p>
            <p style="text-align:center;">
              <a href="https://www.connect.smbf.global/connections" target="_blank"
                style="background: linear-gradient(221deg, #2366CD 0%, #3A97A4 100%);
                color:#ffffff; padding:14px 28px; font-size:16px; text-decoration:none;
                border-radius:6px; display:inline-block;">
                View Connection Request
              </a>
            </p>
            <p style="margin:30px 0 0; font-size:13px; color:#555555;">
              Best regards,<br/>The SMBF Team
            </p>
          </td>
        </tr>
      </table>
    </td>
  </tr>
  <tr>
    <td align="center" style="padding:20px; font-size:11px; color:#888888;">
      &copy; 2025 SMBF. All rights reserved.
    </td>
  </tr>
</table>
</body></html>`;
}

export function getAcceptanceEmailBody(firstName?: string): string {
  return `<!DOCTYPE html><html lang="en"><head>
<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0"/>
<title>Connect by SMBF</title>
</head><body style="margin:0; padding:0; font-family:Arial, Helvetica, sans-serif; background-color:#f4f6f8;">
<table width="100%" border="0" cellspacing="0" cellpadding="0" bgcolor="#f4f6f8">
  <tr>
    <td align="center" style="padding:40px 20px;">
      <table width="600" border="0" cellspacing="0" cellpadding="0" bgcolor="#ffffff"
        style="border-radius:10px; border:1px solid #e0e0e0; overflow:hidden;">
        <tr>
          <td align="center" style="background: linear-gradient(221deg, #2366CD 0%, #3A97A4 100%); padding:30px;">
            <img src="https://drive.google.com/uc?export=view&id=17bPec3b1DFm41gg757oKNyTmP1942OMg"
              alt="Connect by SMBF" width="180"
              style="max-width:180px; height:auto; display:block; margin:0 auto;" />
          </td>
        </tr>
        <tr>
          <td style="padding:35px; text-align:left; color:#333333; font-size:15px; line-height:1.6;">
            <h2 style="color:#2366CD; font-size:22px; margin:0 0 20px;">
              Assalamu Alaikum ${firstName ?? ""},
            </h2>
            <p style="margin:0 0 15px;">
              Your connection request has been accepted.
            </p>
            <p style="margin:0 0 25px;">
              You're now connected — message them anytime and explore ways to collaborate.
            </p>
            <p style="text-align:center;">
              <a href="https://www.connect.smbf.global/messages" target="_blank"
                style="background: linear-gradient(221deg, #2366CD 0%, #3A97A4 100%);
                color:#ffffff; padding:14px 28px; font-size:16px; text-decoration:none;
                border-radius:6px; display:inline-block;">
                Message Now
              </a>
            </p>
            <p style="margin:30px 0 0; font-size:13px; color:#555555;">
              Best regards,<br/>The SMBF Team
            </p>
          </td>
        </tr>
      </table>
    </td>
  </tr>
  <tr>
    <td align="center" style="padding:20px; font-size:11px; color:#888888;">
      &copy; 2025 SMBF. All rights reserved.
    </td>
  </tr>
</table>
</body></html>`;
}
